import { FolderTreeItem } from "../useQueryFolderTree";

// Remove folder tree item in tree recursively
export const removeFolderFromTree = (
  folderTree: FolderTreeItem[],
  folderToRemoveId: string,
) => {
  const filtered = folderTree.reduce((array, folder: FolderTreeItem) => {
    const matchingChildren = folder.children?.length
      ? removeFolderFromTree(
          folder.children as FolderTreeItem[],
          folderToRemoveId,
        )
      : [];
    if (String(folder.id) !== String(folderToRemoveId)) {
      array.push({
        ...folder,
        children: matchingChildren,
      } as FolderTreeItem);
    }
    return array;
  }, [] as FolderTreeItem[]);
  return filtered;
};
